import { withInstall } from "../utils/index.mjs";
import _Sticky from "./Sticky.mjs";
const Sticky = withInstall(_Sticky);
var stdin_default = Sticky;
import { stickyProps } from "./Sticky.mjs";
export {
  Sticky,
  stdin_default as default,
  stickyProps
};
